import React, { useEffect, useState, useContext, useRef } from 'react';
import http from '../../Http';
import utils from '../../utils';
import { useTranslation } from 'react-i18next';
import RealtimeMonitorUhomeSinglePhaseNoCombination from './RealtimeMonitorUhomeSinglePhaseNoCombination.js';
import RealtimeMonitorUhomeSinglePhaseCombination from './RealtimeMonitorUhomeSinglePhaseCombination/RealtimeMonitorUhomeSinglePhaseCombination.js';

function RealtimeMonitorUhomeSinglePhase(props) {
    const setTip = useContext(utils.tipContext)
    const { inverterSelectOptions, SN, protocol, model, isBalcony, handleSelectSN } = props
    const { t } = useTranslation();

    const [InverterConnectionMode, setInverterConnectionMode] = useState(null);
    const [Combinations, setCombinations] = useState();


    //获取具体逆变器详细数据
    useEffect(() => {
        if (!SN) {
            return;
        }
        let active = true;

        (async () => {
            let resp = await http.post("integrated-inverter/uhome-singlephase/real-time/get", { SerialNumber: SN }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load inverter details error") });
                return;
            }

           if (resp.data != null) { 
                setInverterConnectionMode(resp.data.InverterConnectionMode) 
                setCombinations(resp.data.Combinations)
           }

        })();

        return () => {
            active = false;
        };
    }, [SN])

    return (
        <div style={{ width: '100%', height: '100%' }}>{InverterConnectionMode == 1 || InverterConnectionMode == 2 || InverterConnectionMode == 3 || InverterConnectionMode == 4 ?
            <RealtimeMonitorUhomeSinglePhaseCombination inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} model={model} handleSelectSN={handleSelectSN} Once_Combinations={Combinations} {...props} />
            :
            // <RealtimeMonitorUhomeSinglePhaseNoCombination inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} model={model} isBalcony={isBalcony} handleSelectSN={handleSelectSN} />
            <RealtimeMonitorUhomeSinglePhaseCombination inverterSelectOptions={inverterSelectOptions} SN={SN} protocol={protocol} model={model} handleSelectSN={handleSelectSN} Once_Combinations={Combinations} {...props} />
        }</div>
    );
}

export default RealtimeMonitorUhomeSinglePhase;